<template>
  <v-footer
  style="background: rgba(130, 140, 150, 0.7); opacity: 0.9;">
    <v-row
      no-gutters
      class="pb-6 footer"
      align-items="center"
      v-show="!$vuetify.breakpoint.mobile">
      <v-col
        cols="12"
        md="3"
        xs="12"
        sm="12"
        align-self="center"
        align="center"
      >
        <v-img
          src="@/assets/logobottom.png"
          max-width="146px"
          max-height="75px"
        ></v-img>
      </v-col>
      <v-col cols="12" md="5" xs="12" sm="12" align-self="center">
        <div>
          <span style="font-size: 18px; font-weight: 600; color:white;"
            >{{$t("Homepage.company") }}</span
          >
        </div>
        <br />
        <div>
          <span style="font-size: 16px; font-weight: 400; color: white;">
            {{$t("Homepage.address1") }}
          </span>
        </div>
        <div>
          <span style="font-size: 16px; font-weight: 400; color: white;">
            {{$t("Homepage.address2") }}
          </span>
        </div>
        <div>
          <span style="font-size: 16px; font-weight: 400; color: white;">
            {{$t("Homepage.address3") }}
          </span>
        </div>
      </v-col>
      <v-col
        md="1"
        style="margin-left: -100px; margin-right: -80px;"
        align-self="center"
      >
        <div class="lineFooter"></div>
      </v-col>
      <v-col cols="12" md="3" xs="12" sm="12" align-self="center">
        <div class="pb-2">
          <v-icon color="white">mdi-email</v-icon
          ><span style="color: white; font-size:15px;" class="pl-2"
            >nockkc@inet.co.th</span
          >
        </div>
        <div>
          <v-icon color="white">mdi-phone</v-icon
          ><span style="color: white; font-size:15px;" class="pl-2"
            >02 257 7127</span
          >
        </div>
      </v-col>
    </v-row>
    <!-- xs -->
    <v-row
      no-gutters
      class="pt-6 pb-6"
      align-items="center"
      v-show="$vuetify.breakpoint.mobile"
    >
      <v-col cols="12" md="3" xs="12" sm="12">
        <div align="center" class="pb-2">
          <v-img
            src="@/assets/logobottom.png"
            max-width="178px"
            max-height="86px"
          ></v-img>
        </div>
      </v-col>
      <v-col cols="12" md="4" xs="12" sm="12" class="pt-6 pl-5">
        <div>
          <span
            class="text-left"
            style="font-size: 18px; font-weight: 600; color:white;"
            >{{$t("Homepage.company") }}</span
          >
        </div>
        <br />
        <div>
          <span style="font-size: 16px; font-weight: 400; color: white;">
            {{$t("Homepage.address1") }}
          </span>
        </div>
        <div>
          <span style="font-size: 16px; font-weight: 400; color: white;">
            {{$t("Homepage.address2") }}
          </span>
        </div>
        <div>
          <span style="font-size: 16px; font-weight: 400; color: white;">
            {{$t("Homepage.address3") }}
          </span>
        </div>
      </v-col>
      <v-col cols="12" md="2" xs="12" sm="12" class="text-left pl-5">
        <br />
        <div class="pb-2">
          <v-icon color="white">mdi-email</v-icon
          ><span style="color: white; font-size:15px;" class="pl-2"
            >nockkc@inet.co.th</span
          >
        </div>
        <div>
          <v-icon color="white">mdi-phone</v-icon
          ><span style="color: white; font-size:15px;" class="pl-2"
            >02 257 7127</span
          >
        </div>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
export default {
  methods: {
    async toPrivacy() {
      // window.open('https://inet.co.th/assets/html/data_policy.html', '_blank')
      // window.open('/PrivacyNotice', '_blank')
      await this.axios
        .get(process.env.VUE_APP_API + "/api/downloadfile/PrivacyNotice/", {
          responseType: "arraybuffer"
        })
        .then(res => {
          // console.log(res)
          const blob = new Blob([res.data], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "InformationPrivacyNotice.pdf";
          link.click();
        });
    },
    async openTerms() {
      // window.open('/TermsofUse', 'blank')
      // http://localhost:9213/
      await this.axios
        .get(process.env.VUE_APP_API + "/api/downloadfile/termOfuse", {
          responseType: "arraybuffer"
        })
        .then(res => {
          // console.log(res)
          const blob = new Blob([res.data], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "InformationTermsOfUse.pdf";
          link.click();
        });
    },
    async downloadFile() {
      await this.axios
        .get(
          process.env.VUE_APP_API +
            "/api/downloadfile/InformationSecurityPolicyPublic/",
          { responseType: "arraybuffer" }
        )
        .then(res => {
          // console.log(res)
          const blob = new Blob([res.data], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = "InformationSecurityPolicyPublic.pdf";
          link.click();
        });
    }
  }
};
</script>

<style scoped>
.lineFooter {
  height: 166px;
  width: 0px;
  border: 1px solid #ffffff;
  background-color: white;
}

.footer {
  color: blue;
}
</style>
